import { render, staticRenderFns } from "./CommentChrome.vue?vue&type=template&id=76b48b5a&scoped=true&"
import script from "./CommentChrome.vue?vue&type=script&lang=js&"
export * from "./CommentChrome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b48b5a",
  null
  
)

export default component.exports